//
//
//  Require Logged In
//
//

import { useContext } from "react";
import { Outlet } from "react-router-dom";
import { KeycloakContext } from "./KeycloakProvider";
import { LoadingOverlay } from "@mantine/core";
import InternalError from "./InternalError";

function RequireLoggedIn() {
  const { keycloak, initialized } = useContext(KeycloakContext);

  if (!initialized) {
    // Keycloak aún se inicializa
    return <LoadingOverlay visible loaderProps={{ size: "xl", variant: "oval" }} />;
  }

  if (initialized && keycloak && !keycloak.authenticated) {
    // No autenticado, redirige a Keycloak login
    keycloak.login({ redirectUri: window.location.href });
    return <LoadingOverlay visible loaderProps={{ size: "xl", variant: "oval" }} />;
  }

  if (!keycloak?.token || keycloak.isTokenExpired()) {
    return <InternalError />;
  }

  // Usuario autenticado y token válido
  return <Outlet />;
}

export default RequireLoggedIn
